import { useEffect, useState } from 'react';

import { isMobile } from '../../../../../utils/isMobile';
export const useEmoji = (): [boolean, (v: boolean) => void] => {
	const [showEmoji, setShowEmoji] = useState(false);

	useEffect(() => {
		if (showEmoji && !isMobile) {
			const f = (e: MouseEvent): void => void (!e.defaultPrevented && setShowEmoji(false));
			document.addEventListener('mousedown', f);
			return (): void => document.removeEventListener('mousedown', f);
		}
	}, [showEmoji]);

	return [showEmoji, setShowEmoji];
};
